/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetFolderFileContentQueryResponse, ArtifactsControllerGetFolderFileContentPathParams, ArtifactsControllerGetFolderFileContent404 } from "../../models/documentArtifactsController/ArtifactsControllerGetFolderFileContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerGetFolderFileContent } from "../../clients/document-artifactsService/artifactsControllerGetFolderFileContent";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerGetFolderFileContentQueryKey = (documentId: ArtifactsControllerGetFolderFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFolderFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFolderFileContentPathParams["artifactId"], fileName: ArtifactsControllerGetFolderFileContentPathParams["fileName"]) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/files/:fileName/content',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId,
    fileName: fileName
  }
}] as const;
export type ArtifactsControllerGetFolderFileContentQueryKey = ReturnType<typeof artifactsControllerGetFolderFileContentQueryKey>;
export function artifactsControllerGetFolderFileContentQueryOptions(documentId: ArtifactsControllerGetFolderFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFolderFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFolderFileContentPathParams["artifactId"], fileName: ArtifactsControllerGetFolderFileContentPathParams["fileName"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerGetFolderFileContentQueryKey(documentId, renditionId, artifactId, fileName);
  return queryOptions<ArtifactsControllerGetFolderFileContentQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFolderFileContent404>, ArtifactsControllerGetFolderFileContentQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId && fileName),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerGetFolderFileContent(documentId, renditionId, artifactId, fileName, config);
    }
  });
}

/**
 * @description Retrieves the content of a specific file within a FOLDER type artifact
 * @summary Get content of a file within a folder artifact
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/files/:fileName/content}
 */
export function useArtifactsControllerGetFolderFileContent<TData = ArtifactsControllerGetFolderFileContentQueryResponse, TQueryData = ArtifactsControllerGetFolderFileContentQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerGetFolderFileContentQueryKey>(documentId: ArtifactsControllerGetFolderFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFolderFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFolderFileContentPathParams["artifactId"], fileName: ArtifactsControllerGetFolderFileContentPathParams["fileName"], options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerGetFolderFileContentQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFolderFileContent404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerGetFolderFileContentQueryKey(documentId, renditionId, artifactId, fileName);
  const query = useQuery({
    ...artifactsControllerGetFolderFileContentQueryOptions(documentId, renditionId, artifactId, fileName, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerGetFolderFileContent404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}